import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { useQueryParamTerm, useValidatedCrmSuiteQueryParamTerm } from 'pricing-pages-ui/utils/urls/appQueryParamUtils';
import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { usePurchaseOptionsForProductsForTerm } from '../../../hooks/usePurchaseOptions';
import { currentSuiteSkuIdsForProductLevelSelector, skuIdHasBundledProductsSelector } from '../../../selectors/ProductsSelectors';
export const useCrmSuitePricingInfo = ({
  productLevel,
  termOverride
}) => {
  const isAppReady = useGlobalLoading();
  const suiteProductConfigurations = useSelector(state => {
    if (!isAppReady) return [];
    return suiteProductConfigurationsSelector(state, {
      productLevel
    });
  });
  const {
    queryParamTerm: unbundledQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const hasBundledSuite = useSelector(state => {
    if (!isAppReady) return false;
    return suiteProductConfigurations.find(config => skuIdHasBundledProductsSelector(state, {
      skuId: config.skuId
    }));
  });
  const bundledQueryParamTerm = hasBundledSuite ? queryParamTerm : null;
  const queryParamTermToUse = termOverride || bundledQueryParamTerm || unbundledQueryParamTerm;
  const {
    loading: loadingPricingDataForSuite,
    pricingData: pricingInfo
  } = usePurchaseOptionsForProductsForTerm({
    productConfigurations: suiteProductConfigurations,
    term: queryParamTermToUse
  });
  const loading = !isAppReady || loadingPricingDataForSuite;
  return {
    pricingInfo,
    loading
  };
};
export const useCrmSuiteBundleSkuId = ({
  productLevel
}) => {
  const isAppReady = useGlobalLoading();
  const skuIds = useSelector(state => {
    if (!isAppReady) return [];
    return currentSuiteSkuIdsForProductLevelSelector(state, {
      productLevel
    });
  });
  return skuIds && skuIds.length === 1 ? skuIds[0] : undefined;
};